import React from 'react';
import withView from '../../../cmn/docAutomation/withView';
import FormInputRedirect from '../../../../library/form/components/FormInputRedirect';
import FormAttachment from '../../../../library/form/components/FormAttachment';
import FormROValue from '../../../../library/form/components/FormROValue1';
import FormLink from '../../../../library/form/components/FormLink';
import SarasTrans from '../../../../library/notifications/SarasTrans';
import FormLabel from '../../../../library/form/components/FormLabel';
import FormButton from '../../../../library/form/components/FormActionButton2';
import FormTitle from '../../../../library/form/components/FormTitle';
import FormStatus from '../../../../library/form/components/FormStatus';
import DocFormReview from "../../../cmn/docReviewStatus/DocFormReview"
import { UiView, UiViewHeading, UiTitle, UiAction, UiViewContent, UiGridColTwo, UiCol } from "../../../../library/layout/Index";
import DocAdminInfo from '../../../cmn/DocAdminInfo';

const BomHeaderView = (props) => {
    const { formObject, viewData } = props;

    if (!viewData)
        return (null)

    return (
        <UiView>
            <UiViewHeading>
                <UiTitle>
                    <span><FormTitle formObject={formObject} value='Header' /></span>
                </UiTitle>
                <UiAction>
                    <DocAdminInfo formObject={formObject} rowKey="" headerKey="adminInfo"/>
                    <FormButton formObject={formObject} ksc="h" rowKey=""
                        starIcon={"edit"}
                        action={{ actionId: "edit",  actionParam: {}, containerKey: "popup" }}
                        className="uiActionButton" text={<SarasTrans value="Edit" />}></FormButton>
                </UiAction>
            </UiViewHeading>

            <UiViewContent>
                <div className="uiFlexDistributed">
                    <div>
                        <FormAttachment formObject={formObject} rowKey="" action={{ InputType: "i", paramName: "targetItemImage" }} />
                    </div>
                    <div>
                        <ul>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "targetItemId" }} value="Design ID" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "targetItemId" }} className='' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "targetItemName" }} value="Design Name" />
                                </span>
                                <FormLink formObject={formObject} rowKey="" linkProp={{ target: "_blank" }}
                                    action={{ paramName: "targetItemName", actionId: "show", actionName: "itemComp" }}
                                />
                            </li>
                        </ul>
                    </div>
                    <div className='uiFlexBox'>
                        <FormButton formObject={formObject} rowKey="" 
                            action={{ paramName: "createNewAction", actionName: 'bomComp', actionId: "refresh", containerKey: "redirect",  actionParam: {actionType: 'createBlank'} }}
                            className="uiActionButton uiSpacerH10" text={<SarasTrans value="Create Variance: Blank" />}></FormButton>
                        <FormButton formObject={formObject} rowKey=""
                            action={{ paramName: "createVarianceAction", actionName: 'bomComp', actionId: "refresh", containerKey: "redirect",  actionParam: {actionType: 'createVariance'} }}
                            className="uiActionButton uiSpacerH10" text={<SarasTrans value="Create Variance: Copy This" />}></FormButton>
                        <FormButton formObject={formObject} rowKey=""
                            action={{ paramName: "recalculateCostAction",
                            actionMessage: "PleaseWait",
                            actionName: 'bomComp', actionId: "refresh", refreshMode:"dep", actionParam: {actionType: 'recalculateCost'} }}
                            className="uiActionButton uiSpacerH10" text={<SarasTrans value="Recalculate BOM Cost" />}></FormButton>
                    </div>
                </div>
                <UiGridColTwo>
                    <UiCol>
                        <ul>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "bomName" }} value="BOM Name" />
                                </span>
                                <FormInputRedirect formObject={formObject} rowKey="" 
                                    style={{width:"350px"}}
                                    action={{ paramName: "bomName", acMethod: "TargetItemBom", 
                                    acDepCtrl: { 'dparam': '%dataList.valLDT', 'tdtId': '%dataList.tdtId',  'tdId': '%dataList.tdId'},
                                    actionParam:{module:"item", view:"bom"} }} className='' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "type" }} value="Category" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "type" }} className='uiSpacerH10' />

                                <span className="uiLblInLine">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "subType" }} value="Sub Category" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "subType" }} className='uiSpacerH10' />
                            </li>
                            <li style={{display:"none"}}>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "qcTemplate" }} value="QC Template" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "qcTemplate" }} className='uiSpacerH10' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "budget" }} value="Budget" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "budget" }} className='uiSpacerH10' />

                                <span className="uiLblInLine">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "currency" }} value="Currency" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "currency" }} className='uiSpacerH10' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "designer1" }} value="1st Designer" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "designer1" }} className='uiSpacerH10' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "designer2" }} value="2nd Designer" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "designer2" }} className='uiSpacerH10' />
                            </li>
                            <li className='uiMultiValue'>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "isActive" }} value="Active" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "isActive" }} className='uiSpacerH10' />

                                <span className="uiLblInLine">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "isDefault" }} value="Default" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "isDefault" }} className='uiSpacerH10' />
                            </li>
                            <li className='uiMultiValue'>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "isPreCal" }} value="Pre-Cal" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "isPreCal" }} className='uiSpacerH10' />
                                <span className="uiLblInLine">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "isComplete" }} value="Complete" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "isComplete" }} className='uiSpacerH10' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "createdOn" }} value="Created On" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "createdOn" }} className='uiSpacerH10' />
                                <span className="uiLblInLine">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "createdBy" }} value="By" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "createdBy" }} className='uiSpacerH10' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "endOn" }} value="Approved On" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "endOn" }} className='uiSpacerH10' />
                            </li>
                        </ul>
                    </UiCol>
                    <UiCol>
                        <ul>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "docID" }} value="BOM ID" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "docID" }} className='uiSpacerH10' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "review" }} value="Review" />
                                </span>
                                <DocFormReview formObject={formObject} />
                                <span className="uiLblInLine">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "docStatus" }} value="Status" />
                                </span>
                                <FormStatus formObject={formObject} rowKey="" headerKey="docStatus"/>
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "prodQty" }} value="BOM Qty" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "prodQty" }} className='uiSpacerH10' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "projectId" }} value="Project ID" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "projectId" }} className='uiSpacerH10' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "reserve" }} value="Reserve" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "reserve" }} className='uiSpacerH10' />

                                <span className="uiLblInLine">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "markup" }} value="Markup" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "markup" }} className='uiSpacerH10' />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "preCal" }} value="Pre-Cal On" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "preCal" }} className='uiSpacerH10' />
                            </li>
                            <li>
                                <table style={{width:'200px'}}>
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th><SarasTrans value='Est. Value' /></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td><span className="uiLbl"><SarasTrans value='Material' /></span></td>
                                            <td className='uiContentRight'>
                                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "materialPreCal" }} className='' />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><span className="uiLbl"><SarasTrans value='Process' /></span></td>
                                            <td className='uiContentRight'>
                                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "processPreCal" }} className='' />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><span className="uiLbl"><SarasTrans value='OH' /></span></td>
                                            <td className='uiContentRight'>
                                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "ohPreCal" }} className='' />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><span className="uiLbl"><SarasTrans value='Total Before Reserve' /></span></td>
                                            <td className='uiContentRight'>
                                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "totalPreCal" }} className='' />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><span className="uiLbl"><SarasTrans value='Reserve' /></span></td>
                                            <td className='uiContentRight'>
                                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "totalReserve" }} className='' />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><span className="uiLbl"><SarasTrans value='Total After Reserve' /></span></td>
                                            <td className='uiContentRight'>
                                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "totalAfterReserve" }} className='' />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "comment" }} value="Comments" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "comment" }} className='uiSpacerH10' />
                            </li>
                        </ul>
                    </UiCol>
                </UiGridColTwo>
            </UiViewContent>

        </UiView>
    )
}

export default withView(BomHeaderView, "bomHeader", "bomHeader,bomItem,bomProcess");